/** Reads the message(s) of an error rejected by clientApi. */
export const getApiErrorMessage = (error: unknown, fallback: string) => {
  const data = error as { messages?: string[]; message?: string } | undefined

  if (data?.messages?.length) {
    return data.messages.join(' ')
  }

  return data?.message || fallback
}
